import { createContext, useCallback, useContext, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // undefined = still checking, null = guest, object = authenticated
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API}/auth/me`, { credentials: "include" });
      if (!res.ok) throw new Error("guest");
      setUser((await res.json()) ?? null);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    // Returning from OAuth: AuthCallback exchanges the session_id first — skip the /me check.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const login = useCallback((returnPath) => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const path = typeof returnPath === "string" ? returnPath : "/commons";
    const redirectUrl = window.location.origin + path;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }, []);

  const logout = useCallback(async () => {
    try {
      await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
    } catch {
      /* clear locally regardless */
    }
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
